import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { ASSET_FIELDS_URLS } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { ASSET_FIELDS } = ASSET_FIELDS_URLS;

export const assetFieldsApi = createApi({
  reducerPath: 'assetFieldsApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getAssetFields: builder.query({
      query: (params) => ({ url: `${ASSET_FIELDS}${buildQueryString(params)}`, method: GET })
    }),
    addAssetField: builder.mutation({
      query: (data) => ({ url: ASSET_FIELDS, method: POST, data })
    }),
    editAssetField: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ASSET_FIELDS}/${id}`,
        method: PUT,
        data
      })
    }),
    deleteAssetField: builder.mutation({
      query: (id) => ({
        url: `${ASSET_FIELDS}/${id}`,
        method: DELETE
      })
    })
  })
});

export const {
  useGetAssetFieldsQuery,
  useAddAssetFieldMutation,
  useEditAssetFieldMutation,
  useDeleteAssetFieldMutation
} = assetFieldsApi;
